import React from "react";
import CookieSettingsLink from "./CookieSettingsLink";
import { useSelector } from "react-redux";
import { get } from "lodash";
import PrismicRichText from "../PrismicRichText";
import AccessibilitySwitch from "../AccessibilitySwitch";
import Link from "../Link";

export default function Footer() {
  const componentLoading = useSelector((state) =>
    get(state, "prismic.footer.loading", true),
  );
  const component = useSelector((state) =>
    get(state, "prismic.footer.data", false),
  );

  const year = new Date().getFullYear();

  const linkResolver = (doc) => {
    return `/${doc.uid}`;
  };

  const renderFooterLinks = (links) => {
    return links.map((el, i) => (
      <PrismicRichText linkResolver={linkResolver} render={el.content} />
    ));
  };

  return (
    !componentLoading &&
    component && (
      <footer className="standard-padding">
        <div className="wrapper footer-wrapper">
          <div className="footer-section">
            <div className="cookie-settings mb-10">
              {renderFooterLinks(component.footer)}
              <CookieSettingsLink />
            </div>
            <p className="copyright">©{year} Altus LLC, All Rights Reserved.</p>
            <div className="accessibility">
              <AccessibilitySwitch />
            </div>
          </div>
        </div>
      </footer>
    )
  );
}
